var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadFillGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_14534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1604 17.6731V17.4534C31.1604 11.2995 26.2497 6.46436 19.9997 6.46436C14.4194 6.46436 9.73186 10.4204 9.06222 15.9149C5.04436 17.2336 2.14258 20.7501 2.14258 25.1457C2.14258 30.6402 6.60686 35.0358 12.1872 35.0358C15.9819 35.0358 25.3569 35.0358 28.9283 35.0358C33.839 35.0358 37.8569 31.0797 37.8569 26.2446C37.8569 22.0687 34.9551 18.772 31.1604 17.6731Z",
    fill: "url(#paint0_linear_573_14534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.231 24.0466V30.64H17.7667V24.0466H11.0703L19.9989 15.2554L28.9275 24.0466H22.231Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_573_14534",
    x1: 19.9997,
    y1: 6.46436,
    x2: 19.9997,
    y2: 35.0358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65EDB9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_14534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.7143,
    height: 28.5714,
    fill: "white",
    transform: "translate(2.14258 6.46436)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadFillGreen);
export default __webpack_public_path__ + "static/media/icon_upload_fill_green.b09254fd7a06d1d11ee4ac3bbb4cd2f3.svg";
export { ForwardRef as ReactComponent };